module.exports = __webpack_public_path__ + "static/img/major_pictgrid22_960x870.ab6ae85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid22_960x870.jpg
// module id = se32
// module chunks = 0